import React from "react"
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import { LoginPage } from "../pages/login/LoginPage";
import { RootPage } from "../pages/root/RootPage";
import { useProfile } from "../hooks/useProfile";
import { PasswordResetPage } from "../pages/security/PasswordResetPage";
import { useStoreSelector } from "../hooks/redux/useStoreSelector";
import { BackendUnavailable } from "../pages/general/BackendUnavailable";

export const Routing = () => {
  const { profile } = useProfile(),
    backendOnline = useStoreSelector((s) => s.system.backendOnline);
  
  return (
    <>
      <BrowserRouter>
        <Switch>
          <Route path='/backend-unavailable'>
            {backendOnline ? <Redirect to="/" /> : <BackendUnavailable />}
          </Route>
          <Route path='/reset-password'>
            {backendOnline ? (profile ? <Redirect to="/" /> : <PasswordResetPage />) : <Redirect to='/backend-unavailable'/>}
          </Route>
          <Route exact path="/login">
            {backendOnline ? (profile ? <Redirect to="/" /> : <LoginPage />) : <Redirect to='/backend-unavailable'/>}
          </Route>
          <Route path="/">
            {backendOnline ? (profile ? <RootPage /> : <Redirect to="/login" />) : <Redirect to='/backend-unavailable'/>}
          </Route>
        </Switch>
      </BrowserRouter>
    </>
  )
}
